import { render } from "./Chip.vue?vue&type=template&id=0c977ebf"
import script from "./Chip.vue?vue&type=script&lang=js"
export * from "./Chip.vue?vue&type=script&lang=js"

import "./Chip.vue?vue&type=style&index=0&id=0c977ebf&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/pro/Components/Chip.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c977ebf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c977ebf', __exports__)) {
    api.reload('0c977ebf', __exports__)
  }
  
  module.hot.accept("./Chip.vue?vue&type=template&id=0c977ebf", () => {
    api.rerender('0c977ebf', render)
  })

}


export default __exports__